import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=a57a1886&scoped=true&"
import script from "./consume.vue?vue&type=script&lang=js&"
export * from "./consume.vue?vue&type=script&lang=js&"
import style0 from "./consume.vue?vue&type=style&index=0&id=a57a1886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57a1886",
  null
  
)

export default component.exports